import { ArtButton } from "components/button";
import { TextInput } from "components/input/text-input";
import { AuthInterface } from "interfaces";
import { useEffect, useState } from "react";
import {
    Checkbox,
    Modal,
} from "semantic-ui-react";
import { api, ui } from "services";
import { PasswordInput } from "../../components/input/password-input";

export default function EditFarmerPopup({ open, onClose, data, onSuccess }: any) {
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [check2FA, setCheck2FA] = useState(false);
    function close() {
        onClose();
    }
    const onSubmit = async () => {
        setLoading(true);
        try {
            await api.editFarmer(data?.[AuthInterface.identity], newPassword, check2FA);
            onSuccess && onSuccess();
            ui.alertSuccess("Edit farmer information successful !", "");
            resetState();
            onClose();
        } catch (err: any) {
            ui.alertFailed(
                "Edit farmer information failed !",
                "Please try again later !"
            );
            resetState();
            onClose();
        }
    }
    const resetState = () => {
        setLoading(false);
        setNewPassword("");
        setConfirmPassword("");
    }

    useEffect(() => {
        setCheck2FA(data?.G || false);
    }, [data])

    return (
        <Modal
            size="small"
            open={open}
            style={{ width: "unset" }}
        >
            <div
                className="max-w-[564px] w-screen"
            >
                <div className="max-w-[564px] w-screen bg-black-secondary pb-8">
                    <div>
                        <div className="text-center text-white text-xl py-6 font-extrabold main-font-bold">
                            Edit user
                        </div>
                        <img src="/assets/images/hr.svg" alt="hr" className="w-full object-cover h-1 mb-6" />

                        <form className="w-11/12 mx-auto">
                            <TextInput
                                autoFocus
                                fieldName="Username"
                                value={data?.[AuthInterface.identity]}
                                setValue={() => { }}
                                disabled={true}
                            />
                            <PasswordInput
                                submit={onSubmit}
                                fieldName="New password" setPassword={setNewPassword} password={newPassword} className="my-0" />
                            <PasswordInput
                                submit={onSubmit}
                                fieldName="Confirm new password"
                                setPassword={setConfirmPassword}
                                password={confirmPassword}
                                validation={(data: any) => {
                                    if (data !== newPassword) {
                                        return "Confirm password not match with new password"
                                    }
                                    return "";
                                }}
                            />
                            <div className="flex mt-2">
                                <Checkbox
                                    toggle
                                    checked={check2FA}
                                    onChange={(e) => {
                                        setCheck2FA(!check2FA);
                                    }}
                                    className="w-6 h-6"
                                />
                                <span className="text-white ml-2 mt-1">
                                    Required enable second authenticator factor
                                </span>
                            </div>
                        </form>

                        <div className={`flex w-[360px] gap-4 mt-6 text-center items-center mx-auto`}>
                            <ArtButton color="red"
                                disabled={loading}
                                onClick={() => {
                                    close();
                                    resetState();
                                }}
                            >
                                <div className="text-white font-semibold">
                                    Cancel
                                </div>
                            </ArtButton>
                            <ArtButton color="yellow"
                                loading={loading}
                                onClick={onSubmit}
                            >
                                <div className="text-white font-semibold">
                                    Save
                                </div>
                            </ArtButton>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
